//
//
//
//
//
//
//
//
//
//

export default {
	name: 'SupplyManage',
};
